import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { setSubLoading } from '../../Redux/Services/AuthSlice';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, DropDownData, convertToNumber, deleteData, initializeFilterData } from '../CommonComponents/CustomHooks';
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, handleDownloadExcel, readFile } from '../CommonComponents/ExportData';
import { FormButton, ImportButton, InputBox, SelectInputBox, Switch } from '../CommonComponents/InputBox';
import { Table } from '../CommonComponents/Table';
import { CommonApiData } from '../CommonComponents/EnvConfig';

const AssetTypeMaster = () => {
    const inputrefs = useRef([])
    const dispatch = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState([])
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [filterData, setFilterData] = useState(initializeFilterData)
    const [sortConfig, setSortConfig] = useState({ SortColumn: null, SortOrder: null });
    const [Status, setStatus] = useState([])
    const [ImportData, setImportData] = useState([])
    const [Name, setName] = useState('');
    const [formData, setFormData] = useState({
        assetTypeID: '',
        assetTypeCode: 'System Generated',
        productFamilyCode: '',
        assetTypeName: '',
        invoiceNoofDays:'',
        isActive: true
    });
    const GetProductFamilyCode = DropDownData('GetProductFamilyMaster')
    const getAssetTypeMasterData = async (CurrentPage) => {
        let PageIndex = 1
        if (CurrentPage !== undefined && typeof (CurrentPage) !== "object") {
            PageIndex = CurrentPage;
            setCurrentPageNo(CurrentPage);
        }
        else {
            setCurrentPageNo(1);
        }
        const data = {
            ...filterData,
            Type: 'S',
            PageIndex: `${PageIndex}`,
            ...sortConfig
        }
        setIsLoading(true)
        let res = await ApiCall(`/api/Master/ShowAssetTypeMaster`, data)
        if (res.Status === "SUCCESS") {
            setTableData(res)
        } if (res.Status === "ERROR") {
            setTableData([])
        }
        setIsLoading(false)
        if (res.Status === 'EXPIRED') {
            await NotificationSound(res.Status, res.Message, res.focus, inputrefs);
        }
    }

    const handleClear = async() => {
        setFormData({
            assetTypeID: '',
            assetTypeCode: 'System Generated',
            productFamilyCode: '',
            assetTypeName: '',
            invoiceNoofDays:'',
            isActive: true
        });
        await setImportData([])
        await BulkClearData(setName)
        await setName('')
        await setStatus([])
        filterData.SearchText = '';
        setSortConfig({ SortColumn: null, SortOrder: null })
    }

    const handleSubmit = async () => {
        await dispatch(setSubLoading(true))
        let data = await ApiCall(`/api/Master/InsertUpdateAssetTypeMaster`, { ...formData })
        await dispatch(setSubLoading(false))
        await NotificationSound(data.status, data.message, data.focus, inputrefs, handleClear);
    };

    const handleEditData = async (id) => {
        await dispatch(setSubLoading(true))
        let editData = await ApiCall(`/api/Master/EditAssetTypeMaster`, { assetTypeID: id })
        await dispatch(setSubLoading(false))
        if (editData.status === 'UNAUTHORIZED' || editData.status === 'ERROR' || editData.status === 'EXPIRED') {
            await NotificationSound(editData.status, editData.message, editData.focus, inputrefs);
        }
        else {
            setFormData((pre) => ({
                ...pre, ...editData
            }))
        }
    }

    const handleDelete = async (id) => {
        await dispatch(setSubLoading(true))
        await deleteData(`/api/Master/DeleteAssetTypeMaster`, { assetTypeID: id }, getAssetTypeMasterData, handleClear, '', inputrefs)
        await dispatch(setSubLoading(false))
    }

    const handleSorting = (SortColumn) => {
        let SortOrder = 'ASC';
        if (sortConfig && sortConfig.SortColumn === SortColumn && sortConfig.SortOrder === 'ASC') {
            SortOrder = 'DESC';
        }
        setSortConfig({ SortColumn, SortOrder });
    };

    const handleChange1 = (event, value) => {
        getAssetTypeMasterData(value);
    };
    const DownloadFormat = async () => {
        await DownloadFileAtURL('AssetTypeMaster.xlsx')
    };

    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'AssetTypeMasterError')
    }

    const BulkSubmit = async (e) => {
        await dispatch(setSubLoading(true))
        let data = await readFile(e)
        setImportData(data.exceljson)
        setName(data.FileName)
        await dispatch(setSubLoading(false))
    };

    const handleBulk = async () => {
        const Data2 = {
            "authToken": CommonApiData().AuthToken,
            "loginToken": CommonApiData().LoginToken,
            "loginUserCode": CommonApiData().UserCode,
            "companyCode": CommonApiData().CompanyCode,
            assetTypeCode: 'System Generated',

        };
        if (ImportData.length !== 0) {
            if ((Object.keys(ImportData[0])).includes("assetTypeName", "productFamilyCode","invoiceNoofDays", "isActive")) {
                await dispatch(setSubLoading(true))
                let Data = await HandleBulkInsertData('/api/Master/InsertUpdateAssetTypeMaster', ImportData, Data2, getAssetTypeMasterData)
                await setStatus(Data)
                await dispatch(setSubLoading(false))
                await NotificationSound('INFO', `Success : ${Data.SuccessCount} Error : ${Data.ErrorCount}`);
                BulkClearData(setName)

            } else {
                await NotificationSound('ERROR', 'Header Format is not valid !');
                BulkClearData(setName)
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data.!');
            BulkClearData(setName)
        }
    }
    useEffect(() => {
        getAssetTypeMasterData()
        document.title = 'Asset Type Master'
        inputrefs.current['txtAssetTypeName'].focus()
    }, [sortConfig])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='pt-1 row px-3 border-0'>
                    <div className='card-header mb-1'>
                        <h6 className="m-0">  {'Asset Type Master'} </h6>
                    </div>
                    <div className='card-body pb-1 row'>
                        <div className='col-md-6 col-lg-8'>
                            <div className='row'>
                                <InputBox
                                    id="txtAssetTypeCode"
                                    type="text"
                                    label='Asset Type Code'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtAssetTypeName'].focus()
                                        }
                                    }}
                                    inputrefs={inputrefs}
                                    placeholder='System Generated'
                                    name='AssetTypeCode'
                                    value={formData.assetTypeCode}
                                    disabled
                                />
                                <InputBox
                                    id="txtAssetTypeName"
                                    type="text"
                                    label='Asset Type Name'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    required={true}
                                    placeholder="Asset Type Name"
                                    maxLength='50'
                                    value={formData.assetTypeName}
                                    onChange={(e) => setFormData({ ...formData, assetTypeName: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtProductFamilyCode'].focus()
                                        }
                                    }}
                                />
                                <SelectInputBox
                                    id="txtProductFamilyCode"
                                    value={formData.productFamilyCode}
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    label='Product Family'
                                    required={true}
                                    onChange={(e) => setFormData({ ...formData, productFamilyCode: e.target.value })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtInvoiceNoOfDays'].focus()
                                        }
                                    }}
                                >
                                    <option value=''>--Please Select--</option>
                                    {GetProductFamilyCode?.data?.dataList?.map((item, index) =>
                                        <option key={item.name + index} value={item.code}>{item.name}</option>
                                    )}
                                </SelectInputBox>
                                <InputBox
                                    id="txtInvoiceNoOfDays"
                                    type="text"
                                    label='Allow Invoice in Back Days'
                                    divclassname="col-lg-4 col-md-4 col-sm-12 mb-1"
                                    required={true}
                                    placeholder="Allow Invoice in Back Days"
                                    maxLength='2'
                                    value={formData.invoiceNoofDays}
                                    onChange={(e) => setFormData({ ...formData, invoiceNoofDays: convertToNumber(e.target.value) })}
                                    inputrefs={inputrefs}
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['txtActive'].focus()
                                        }
                                    }}
                                />
                                <Switch
                                    inputrefs={inputrefs}
                                    label='Active'
                                    checked={formData.isActive}
                                    id='txtActive'
                                    onKeyDown={(e) => {
                                        if (e.key === 'Enter') {
                                            inputrefs.current['btnSub'].focus()
                                        };
                                    }}
                                    onChange={(e) => setFormData({ ...formData, isActive: e.target.checked })}
                                />
                            </div>
                        </div>
                        <div className='d-flex col-md-6 col-lg-4 h-65 mb-2'>
                            <ImportButton
                                handleBulk={handleBulk}
                                BulkSubmit={(e) => BulkSubmit(e)}
                                downloadFormat={DownloadFormat}
                                ErrorData={ErrorData}
                                Status={Status}
                                HeaderFormat="PayMode, Active"
                                fileName={Name}
                            >
                            </ImportButton>
                        </div>
                        <div className='card-body'>
                            <FormButton
                                id={'btnSub'}
                                inputrefs={inputrefs}
                                handleSubmit={handleSubmit}
                                handleExport={() => handleDownloadExcel(`/api/Master/ShowAssetTypeMaster`, filterData, 'Asset Type Master')}
                                handleClear={handleClear}
                            />
                        </div>
                    </div>

                </div>
            </div>
            <Table
                handleDelete={handleDelete}
                handleEdit={handleEditData}
                loading={isLoading}
                PageName={'AssetTypeMaster'}
                handleFilter={() => {
                    getAssetTypeMasterData()
                    setFilterData({
                        ...filterData,
                    })
                }}
                filterData={filterData}
                tableData={tableData}
                setFilterData={setFilterData}
                currentPageNo={currentPageNo}
                handleChange1={handleChange1}
                handleSorting={handleSorting}
                sortConfig={sortConfig}
            />
        </>
    )
}
export default AssetTypeMaster;